const routes = [
    {
        name: 'listarSituacoesAtendimentos',
        path: 'situacoes',
        alias: 'situacoes/index',
        component: () => import('../views/Listar')
    },
    {
        name: 'adicionarSituacaoAtendimento',
        path: 'situacoes/adicionar',
        component: () => import('../views/Adicionar')
    },
    {
        name: 'editarSituacaoAtendimento',
        path: 'situacoes/editar/:id',
        component: () => import('../views/Editar')
    },
    {
        name: 'visualizarSituacaoAtendimento',
        path: 'situacoes/visualizar/:id',
        component: () => import('../views/Visualizar')
    }
   
]

export default routes



